import { reportEvent } from '../api/tracking'

/**
 * 从 store 获取 userId，静默上报（失败不抛异常）
 */
function track(store, event) {
  if (!store) return
  var userInfo = store.state && store.state.userInfo
  var userId = userInfo && userInfo.userId
  if (!userId) return
  // 后端可能返回数字型或字符串型 userId，数字型转整数
  event.userId = /^\d+$/.test(String(userId)) ? Number(userId) : userId
  reportEvent(event).catch(function() {})
}

/** 解析 gameId 为整数 */
function toGameId(id) {
  if (id === null || id === undefined) return 0
  return Number(id) || 0
}

/** 页面浏览 */
export function trackPageView(store, pageName, isNew) {
  track(store, {
    eventName: 'box_page_view',
    pageName: pageName,
    isNew: isNew || 0
  })
}

/** 游戏盒子点击 */
export function trackBoxClick(store, gameId, source, pageName, isNew) {
  track(store, {
    eventName: 'box_click',
    gameId: toGameId(gameId),
    source: source === 'featured' || source === 'secondary' ? source : '',
    pageName: pageName,
    isNew: isNew || 0,
    eventData: { position: 0, boxType: 'normal' }
  })
}

/** 游戏启动 */
export function trackBoxLaunch(store, gameId, source, pageName, isNew) {
  track(store, {
    eventName: 'box_launch',
    gameId: toGameId(gameId),
    source: source === 'featured' || source === 'secondary' ? source : '',
    pageName: pageName,
    isNew: isNew || 0,
    eventData: {}
  })
}

/** 游戏盒子展示 */
export function trackBoxImpression(store, gameId, source, pageName, isNew) {
  track(store, {
    eventName: 'box_impression',
    gameId: toGameId(gameId),
    source: source === 'featured' || source === 'secondary' ? source : '',
    pageName: pageName,
    isNew: isNew || 0,
    eventData: { position: 0, boxType: 'normal' }
  })
}

/** 用户登录 */
export function trackUserLogin(store, isNew) {
  track(store, {
    eventName: 'user_login',
    isNew: isNew || 0,
    eventData: { loginType: 'auto', deviceType: 'web' }
  })
}
